import script from "./CustomerHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerHeader.vue?vue&type=script&setup=true&lang=js"

import "./CustomerHeader.vue?vue&type=style&index=0&id=b114212a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b114212a"]])

export default __exports__